<div class="table-wrapper">
  <div class="table-scroll">
    <table class="field-table">
      <thead>
        <tr>
          <th class="row-header-cell"></th>
          <th *ngFor="let col of config.columns">{{ col.name }}</th>
          <th *ngIf="config.allowAddRows && !isDisabled" class="action-col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows; let i = index; trackBy: trackByIndex">
          <td class="row-name-cell">
            <ng-container *ngIf="isFixedRow(i); else dynamicRowName">{{ row.rowName }}</ng-container>
            <ng-template #dynamicRowName>
              <input nbInput class="row-name-input"
                     [value]="row.rowName"
                     [disabled]="isDisabled"
                     placeholder="Zeilenname..."
                     (input)="setRowName(i, $any($event.target).value)" />
            </ng-template>
          </td>
          <td *ngFor="let col of config.columns" class="cell">

            <!-- String -->
            <ng-container *ngIf="col.type === 'String'">
              <input nbInput
                     class="cell-input"
                     type="text"
                     [value]="getCellValue(row, col.name)"
                     [disabled]="isDisabled"
                     (input)="setCellValue(row, col.name, $any($event.target).value)" />
            </ng-container>

            <!-- Integer -->
            <ng-container *ngIf="col.type === 'Integer'">
              <input nbInput
                     class="cell-input"
                     type="number"
                     step="1"
                     [value]="getCellValue(row, col.name)"
                     [disabled]="isDisabled"
                     (input)="setCellValue(row, col.name, $any($event.target).value)" />
            </ng-container>

            <!-- Double -->
            <ng-container *ngIf="col.type === 'Double'">
              <input nbInput
                     class="cell-input"
                     type="number"
                     step="0.01"
                     [value]="getCellValue(row, col.name)"
                     [disabled]="isDisabled"
                     (input)="setCellValue(row, col.name, $any($event.target).value)" />
            </ng-container>

            <!-- Boolean -->
            <ng-container *ngIf="col.type === 'Boolean'">
              <div class="bool-toggle" [class.bool-disabled]="isDisabled">
                <button nbButton type="button" size="small"
                        [status]="getCellValue(row, col.name) === 'true' ? 'success' : 'basic'"
                        [class.active]="getCellValue(row, col.name) === 'true'"
                        (click)="setCellValue(row, col.name, 'true')">
                  <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
                  Ja
                </button>
                <button nbButton type="button" size="small"
                        [status]="getCellValue(row, col.name) === 'false' ? 'danger' : 'basic'"
                        [class.active]="getCellValue(row, col.name) === 'false'"
                        (click)="setCellValue(row, col.name, 'false')">
                  <nb-icon icon="close-outline" pack="eva"></nb-icon>
                  Nein
                </button>
              </div>
            </ng-container>

            <!-- Dropdown -->
            <ng-container *ngIf="col.type === 'Dropdown'">
              <nb-select
                class="cell-select"
                [selected]="getCellValue(row, col.name)"
                [disabled]="isDisabled"
                (selectedChange)="setCellValue(row, col.name, $event)">
                <nb-option value="">—</nb-option>
                <nb-option *ngFor="let opt of columnOptions(col)" [value]="opt">{{ opt }}</nb-option>
              </nb-select>
            </ng-container>

          </td>
          <td *ngIf="config.allowAddRows && !isDisabled" class="action-col">
            <button nbButton ghost status="danger" size="tiny" type="button"
                    *ngIf="!isFixedRow(i)"
                    (click)="removeRow(i)">
              <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <button *ngIf="config.allowAddRows && !isDisabled"
          nbButton ghost status="primary" size="small" type="button"
          class="add-row-btn"
          (click)="addRow()">
    <nb-icon icon="plus-outline" pack="eva"></nb-icon>
    Zeile hinzufügen
  </button>
</div>
